<template lang="pug">
form#collection-form(@submit.prevent="submit" name="collection-form" novalidate)
  .modal-card
    header.modal-card-head
      p.modal-card-title(v-once) {{ title }}
    section.modal-card-body.modal-tabs
      b-tabs(
        v-model="activeTab"
        position="is-centered"
        expanded
      )
        b-tab-item(label="Details")
          b-field(label="Title")
            b-input(
              :value="collection.title"
              @input="set($event, 'title')"
            )
          b-field(label="Year")
            b-input(
              :value="collection.year"
              @input="set($event, 'year')"
            )
          b-field(label="Subtitle")
            b-input(
              :value="collection.sub_title"
              @input="set($event, 'sub_title')"
            )
          //- b-field(label="Short Description")
          //-   b-input(
          //-     type="textarea"
          //-     rows="2"
          //-     :value="collection.short_desc"
          //-     @input="set($event, 'short_desc')"
          //-   )
          b-field(label="Description")
            b-input(
              type="textarea"
              rows="5"
              :value="collection.long_desc"
              @input="set($event, 'long_desc')"
            )
        b-tab-item(label="Episodes")
          .search-wrapper
            elasticsearch-multiselect(
              :value="episodeIds"
              field="title"
              icon="magnify"
              index="doxa_episodes"
              placeholder="Add episodes..."
              @input="addEpisode"
            )
          .episodes-wapper
            b-notification(:closable="false" v-if="!collection._embedded.episodes || collection._embedded.episodes.length === 0") No episodes assigned to this collection
            b-table(
              v-else
              :data="collection._embedded.episodes"
            )
              template(slot-scope="props")
                b-table-column(label="Title") {{ props.row.title }}
                b-table-column(label="Date") {{ props.row.pub_date | date }}
                b-table-column
                  a.button.is-small.is-danger(@click="deleteEpisode(props.row)")
                    b-icon(icon="close" size="is-small")
        b-tab-item(label="Cover Art")
          cover-art-tab(
            v-model="artwork"
            :default-image="defaultImage"
            @input="a => artwork = a"
          )
    footer.modal-card-foot
      button.button.is-success(
        type="submit"
        :class="{ 'is-loading': settings.submitting }"
      ) {{ saveBtnLabel }}
      a.button.is-danger(
        @click="confirmDelete"
        :class="{ 'is-loading': settings.deleting }"
      ) Delete
</template>

<script>
import { mapGetters } from 'vuex';
import CoverArtTab from '@/components/form/episode/CoverArtTab';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'speaker-form',
  components: {
    CoverArtTab,
    ElasticsearchMultiselect,
  },
  computed: {
    ...mapGetters({
      collection: getters.GET_COLLECTION,
    }),
    defaultImage() {
      if (this.collection._embedded.artwork.id) {
        return this.collection._embedded.artwork.file.url;
      }
      return null;
    },
    isNew() {
      return this.collection.id === undefined;
    },
    saveBtnLabel() {
      return this.isNew ? 'Save Collection' : 'Save Changes';
    },
    title() {
      return this.isNew ? 'New Collection' : `Edit Collection: ${this.collection.title}`;
    },
  },
  created() {
    this.$store.dispatch(actions.DO_GET_EPISODES_FOR_COLLECTION, {
      id: this.collection.id,
    });
  },
  data() {
    return {
      activeTab: 0,
      artwork: null,
      episodeIds: [],
      settings: {
        deleting: false,
        submitting: false,
      },
    };
  },
  methods: {
    async addEpisode(ids) {
      const id = ids[0];
      const existing = _.map(this.collection._embedded.episodes, 'id');
      if (_.includes(existing, id)) {
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-danger',
          message: 'This episode is already part of the collection.',
        });
        return Promise.reject();
      }
      const { data } = await this.$store.dispatch(actions.DO_ADD_EPISODE_TO_COLLECTION, {
        id: this.collection.id,
        episode_id: id,
      });
      await this.$store.dispatch(actions.DO_GET_COLLECTION, {
        id: this.collection.id,
        zoom: 'artwork,episodes',
      });
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Episode added to collection',
      });
      return data;
    },
    confirmDelete() {
      if (!this.settings.deleting) {
        this.$buefy.dialog.confirm({
          title: 'Are you sure?',
          message: 'Deleting this collection cannot be undone.',
          type: 'is-danger',
          hasIcon: true,
          confirmText: 'Yes, Delete',
          onConfirm: () => this.deleteCollection(),
        });
      }
    },
    async deleteCollection() {
      this.settings.deleting = true;
      const response = await this.$store.dispatch(actions.DO_DELETE_COLLECTION, {
        id: this.collection.id,
        ignore: true,
      });
      setTimeout(() => {
        this.$parent.close();
        this.settings.deleting = false;
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: response.message,
        });
        this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
      }, 1000);
    },
    async deleteEpisode(episode) {
      const { data } = await this.$store.dispatch(actions.DO_DELETE_EPISODE_FROM_COLLECTION, {
        id: this.collection.id,
        episode_id: episode.id,
      });
      await this.$store.dispatch(actions.DO_GET_COLLECTION, {
        id: this.collection.id,
        zoom: 'artwork,episodes',
      });
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Episode removed from collection',
      });
      return data;
    },
    set(val, key) {
      this.$store.commit(mutations.SET_COLLECTION_FIELD, {
        key,
        val,
      });
    },
    async submit() {
      this.settings.submitting = true;
      const action = this.isNew ? actions.DO_CREATE_COLLECTION : actions.DO_UPDATE_COLLECTION;
      const payload = {
        id: this.collection.id,
        long_desc: this.collection.long_desc,
        short_desc: this.collection.short_desc,
        sub_title: this.collection.sub_title,
        title: this.collection.title,
        year: this.collection.year,
        zoom: 'artwork,episodes',
      };
      if (this.artwork) {
        const file = this.artwork.generateDataUrl('image/jpeg');
        const { data } = await this.$store.dispatch(actions.DO_CREATE_MEDIA_IMAGE, { file });
        payload.artwork_id = data.images[0].id;
      }
      const response = await this.$store.dispatch(action, payload);
      setTimeout(() => {
        this.$parent.close();
        this.$store.commit(mutations.SET_APP_SNACKBAR, {
          type: 'is-success',
          message: response.message,
        });
        this.$store.commit(mutations.SET_MEDIA_REFRESH, true);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
#collection-form {
  .search-wrapper {
    margin-bottom: 1rem;
  }
  .episodes-wapper {
    min-height: 260px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/CollectionForm.vue